import { render, staticRenderFns } from "./TaxCollection.vue?vue&type=template&id=01d3a7e6&"
import script from "./TaxCollection.vue?vue&type=script&lang=js&"
export * from "./TaxCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports